<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Communities</h1>
        </div>
        <div class="float-left">
            <el-button @click="create" type="primary" v-if="canCreateCommunity"
                ><i class="mdi mdi-plus" />
                Create
            </el-button>
            <el-input
                @input="onInputSearch"
                placeholder="Search Communities..."
                style="width: 250px; margin-right: 10px"
                v-model="filter.search"
                clearable
            />
            <el-button
                @click="exportReport"
                type="primary"
                v-if="canViewCommunities"
                ><i class="mdi mdi-download" />
                Export Report
            </el-button>
        </div>
        <div class="float-right">
            Filter by:
            <el-select
                @change="onChangeCorporation"
                clearable
                filterable
                placeholder="Corporation..."
                style="width: 200px"
                v-model="filter.corporation_id"
            >
                <el-option label="Independent" value="independent" />
                <el-option
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-for="item in corporations.data"
                />
            </el-select>
        </div>
        <div class="clearfix"></div>
        <div style="margin-top: 20px">
            <el-tabs
                type="card"
                v-model="activeTab"
                @tab-click="handleTabClick"
            >
                <el-tab-pane
                    label="Search Results"
                    name="search"
                    v-if="filter.search"
                >
                    <community-table
                        ref="tab_search"
                        :communities="communities.data"
                        :loading="communities.meta.loading"
                        :pagination="communities.meta.pagination"
                        :can-edit-community="canEditCommunity"
                        @sort-change="onSortChange"
                        @change-suspension-status="changeSuspensionStatus"
                        @edit-item="editItem"
                        @login="login"
                        @current-change="onCurrentPageChange"
                    />
                </el-tab-pane>
                <el-tab-pane
                    label="Active Communities"
                    name="active"
                    v-if="!filter.search"
                >
                    <community-table
                        ref="tab_active"
                        :communities="communities.data"
                        :loading="communities.meta.loading"
                        :pagination="communities.meta.pagination"
                        :can-edit-community="canEditCommunity"
                        @sort-change="onSortChange"
                        @change-suspension-status="changeSuspensionStatus"
                        @edit-item="editItem"
                        @login="login"
                        @current-change="onCurrentPageChange"
                    />
                </el-tab-pane>
                <el-tab-pane
                    label="Inactive Communities"
                    name="inactive"
                    v-if="!filter.search"
                >
                    <community-table
                        ref="tab_inactive"
                        :communities="communities.data"
                        :loading="communities.meta.loading"
                        :pagination="communities.meta.pagination"
                        :can-edit-community="canEditCommunity"
                        @sort-change="onSortChange"
                        @change-suspension-status="changeSuspensionStatus"
                        @edit-item="editItem"
                        @login="login"
                        @current-change="onCurrentPageChange"
                    />
                </el-tab-pane>
                <el-tab-pane
                    label="Suspended Communities"
                    name="suspended"
                    v-if="!filter.search"
                >
                    <community-table
                        ref="tab_suspended"
                        :communities="communities.data"
                        :loading="communities.meta.loading"
                        :pagination="communities.meta.pagination"
                        :can-edit-community="canEditCommunity"
                        @sort-change="onSortChange"
                        @change-suspension-status="changeSuspensionStatus"
                        @edit-item="editItem"
                        @login="login"
                        @current-change="onCurrentPageChange"
                    />
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="clearfix"></div>
        <el-dialog
            :close-on-click-modal="false"
            :title="editingItem ? 'Edit Community' : 'Create Community'"
            :visible.sync="dialogVisible"
            width="600px"
        >
            <el-form @submit.prevent="submit()">
                <el-form-item label="Name" required :class="form.state('name')">
                    <el-input v-model="form.name" />
                    <form-feedback :form="form" field="name" />
                </el-form-item>
                <el-form-item
                    label="Subdomain"
                    required
                    :class="form.state('slug')"
                >
                    <el-input v-model="form.slug" />
                    <form-feedback :form="form" field="slug" />
                </el-form-item>
                <el-form-item
                    label="Community Code"
                    required
                    :class="form.state('code')"
                >
                    <el-input v-model="form.code" />
                    <form-feedback :form="form" field="code" />
                </el-form-item>
                <el-form-item label="Logo" :class="form.state('logo')">
                    <br />
                    <img v-if="logo_src" :src="logo_src" style="width: 200px" />
                    <br />
                    <input
                        @change="onChangeLogo"
                        type="file"
                        style="display: none"
                        ref="inputLogo"
                        accept="image/*"
                    />
                    <el-button
                        icon="mdi mdi-camera"
                        @click="$refs.inputLogo.click()"
                        >Upload Logo</el-button
                    >
                    <form-feedback :form="form" field="logo" />
                </el-form-item>
                <el-form-item
                    label="Corporation"
                    :class="form.state('corporation_id')"
                >
                    <el-select
                        filterable
                        clearable
                        v-model="form.corporation_id"
                        placeholder="Select"
                    >
                        <el-option
                            v-for="item in corporations.data"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    <form-feedback :form="form" field="corporation_id" />
                </el-form-item>
                <el-form-item
                    required
                    label="Account Type"
                    :class="form.state('account_type')"
                >
                    <br />
                    <el-radio-group
                        v-model="form.account_type"
                        class="el-radio-group--one-item-per-line"
                    >
                        <el-radio :label="AccountTypes.CALENDARS_ONLY"
                            >Calendar(s)</el-radio
                        >
                        <el-radio :label="AccountTypes.NEWSLETTER_ONLY"
                            >Newsletter</el-radio
                        >
                        <el-radio :label="AccountTypes.CALENDARS_AND_NEWSLETTER"
                            >Calendar(s) and Newsletter</el-radio
                        >
                    </el-radio-group>
                    <form-feedback :form="form" field="account_type" />
                </el-form-item>
                <el-form-item
                    required
                    v-if="hasNewsletter"
                    label="Newsletter"
                    :class="form.state('newsletter_type_id')"
                >
                    <br />
                    <el-radio-group
                        v-model="form.newsletter_type_id"
                        class="el-radio-group--one-item-per-line"
                    >
                        <el-radio
                            :key="type.id"
                            v-for="type in newsletterTypes"
                            :label="type.id"
                            >{{ type.name }}
                        </el-radio>
                    </el-radio-group>
                    <form-feedback :form="form" field="newsletter_type_id" />
                </el-form-item>
                <el-form-item
                    v-if="hasCalendar"
                    label="Calendar Unit Name"
                    :class="form.state('calendar_unit_name')"
                >
                    <el-input
                        v-model="form.calendar_unit_name"
                        placeholder="ex: Memory Care Unit"
                    />
                    <span class="text-small"
                        >This will go at the top of your calendar along with
                        your community name.</span
                    >
                    <form-feedback :form="form" field="calendar_unit_name" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" :disabled="form.busy"
                    >Cancel</el-button
                >
                <el-button
                    type="primary"
                    icon="mdi mdi-content-save"
                    @click="submit"
                    :loading="form.busy"
                    >Save
                </el-button>
            </div>
        </el-dialog>
    </vue-scroll>
</template>

<script>
import CommunityTable from "@/components/tables/CommunitiesTable.vue";
import * as AccountTypes from "@/constants/account-types";
import * as Permissions from "@/constants/permissions";
import * as Routes from "@/constants/routes";
import auth from "@/mixins/auth";
import backend_paginator from "@/mixins/backend-paginator"; // onSortChange, onCurrentPageChange, updateTableSorting, updateRoute
import community_mixin from "@/mixins/community";
import * as Mutations from "@/store/constants/mutations";
import Utils from "@/utils";
import _ from "lodash";
import moment from "moment";
import qs from "qs";
import { mapState } from "vuex";

const INCLUDE = "locations,formatted_logo,address,custom_charges";

function getData(params = {}) {
    //console.log(params);
    _.extend(params, {
        include: INCLUDE,
        all: 0
    });
    return window.axios.get(`/web-api/community?${qs.stringify(params)}`);
}

export default {
    components: {
        CommunityTable
    },
    mixins: [community_mixin, backend_paginator, auth],
    beforeRouteEnter(to, from, next) {
        let query = _.clone(to.query);
        if (_.isEmpty(query)) {
            query = {
                filter: {
                    name: null,
                    status: "active"
                },
                page: 1,
                sort_by: "name",
                sort_order: "asc"
            };
        }
        getData(query).then((response) => {
            next((vm) => {
                _.extend(
                    vm.currentQuery,
                    _.pick(query, ["sort_by", "sort_order", "page"])
                );
                _.extend(vm.currentQuery.filter, _.get(to, "query.filter"));
                vm.setData(response);
            });
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.communities.meta.loading = true;
        getData(to.query)
            .then((response) => {
                this.setData(response);
                next();
            })
            .finally(() => (this.communities.meta.loading = false));
    },
    data() {
        return {
            activeTab: "active",
            AccountTypes,
            dialogVisible: false,
            form: new Form({
                name: null,
                slug: null,
                logo: null,
                code: null,
                corporation_id: null,
                account_type: null,
                newsletter_type_id: null,
                calendar_unit_name: null
            }),
            logo_src: null,
            editingItem: null,
            filter: {
                search: "",
                corporation_id: null,
                status: "active"
            },
            communities: {
                data: [],
                meta: {
                    pagination: {},
                    loading: false
                }
            },
            currentQuery: {
                filter: {
                    name: null,
                    status: "active"
                },
                page: 1,
                sort_by: "name",
                sort_order: "asc"
            },
            routeName: Routes.COMMUNITIES
        };
    },
    mounted() {
        this.filter.search = _.get(this.$route, "query.filter.name", "");
        this.filter.status = _.get(
            this.$route,
            "query.filter.status",
            "active"
        );
        this.activeTab = this.filter.status;
        if (
            _.has(this.$route.query, "filter") &&
            _.has(this.$route.query.filter, "corporation_id")
        ) {
            this.filter.corporation_id = Utils.emptyOrNull(
                this.$route.query.filter.corporation_id
            )
                ? "independent"
                : parseInt(this.$route.query.filter.corporation_id);
        }
        //this.fetchCommunities();
        Vue.nextTick(() => {
            this.updateTableSorting(this.activeTab);
        });
    },
    computed: {
        ...mapState({
            corporations: (state) => state.corporations,
            newsletterTypes: (state) => state.lists.newsletter_types.data
        }),
        hasNewsletter() {
            return _.includes(
                [
                    AccountTypes.CALENDARS_AND_NEWSLETTER,
                    AccountTypes.NEWSLETTER_ONLY
                ],
                this.form.account_type
            );
        },
        hasCalendar() {
            return _.includes(
                [
                    AccountTypes.CALENDARS_AND_NEWSLETTER,
                    AccountTypes.CALENDARS_ONLY
                ],
                this.form.account_type
            );
        },
        canEditCommunity() {
            return this.can(Permissions.EDIT_COMMUNITY);
        },
        canCreateCommunity() {
            return this.can(Permissions.CREATE_COMMUNITY);
        },
        canViewCommunities() {
            return this.can(Permissions.VIEW_COMMUNITIES);
        }
    },
    methods: {
        fetchCommunities() {
            this.communities.meta.loading = true;
            getData(this.currentQuery)
                .then((response) => {
                    //console.log(response);
                    this.setData(response);
                })
                .finally(() => (this.communities.meta.loading = false));
        },
        handleTabClick(tab) {
            this.currentQuery.filter.status = tab.name;
            //_.extend(this.currentQuery.filter, { status: status });
            this.currentQuery.page = 1;
            this.updateRoute();
            //this.fetchCommunities();
        },
        onInputSearch: _.debounce(function () {
            if (this.filter.search === "") {
                this.currentQuery.filter.name = null;
                this.currentQuery.filter.status = "active";
            } else {
                this.currentQuery.filter.name = this.filter.search;
                this.currentQuery.filter.status = "search";
            }
            this.currentQuery.page = 1;
            this.activeTab = this.currentQuery.filter.status;
            this.updateRoute();
        }, 500),
        setData(response) {
            this.communities.data = response.data.data;
            this.communities.meta.pagination = response.data.meta.pagination;
        },
        create() {
            this.$router.push({
                name: Routes.CREATE_COMMUNITY
            });
        },
        exportReport() {
            let params = _.extend({ export: true }, this.currentQuery);
            window.open(`/web-api/community?${qs.stringify(params)}`);
        },
        onChangeLogo(e) {
            window.Utils.getFileImageData(e.currentTarget).then((response) => {
                this.logo_src = response;
                this.form.logo = e.target.files[0];
            });
        },
        submit() {
            if (this.editingItem) {
                window.App.putData(
                    `/web-api/community/${this.editingItem.id}?include=${INCLUDE}`,
                    this.form
                ).then((response) => {
                    this.dialogVisible = false;
                    this.$notify.success({
                        message: `Changes have been saved`
                    });
                    this.$store.commit(
                        Mutations.UPDATE_COMMUNITY,
                        response.data
                    );
                });
            } else {
                window.App.postData(
                    `/web-api/community?include=${INCLUDE}`,
                    this.form
                ).then((response) => {
                    this.dialogVisible = false;
                    this.$notify.success({
                        message: `New community has been saved.`
                    });
                    this.$store.commit(Mutations.NEW_COMMUNITY, response.data);
                });
            }
        },
        editItem(item) {
            this.$router.push({
                name: Routes.EDIT_COMMUNITY,
                params: {
                    id: item.id
                }
            });
        },
        login(item) {
            window.open(`${this.getCommunityBaseUrl(item)}/home`, "_blank");
        },
        changeSuspensionStatus(community) {
            this.$confirm(
                `Are you sure you want to ${
                    !community.suspended ? "suspend" : "un-suspend"
                } this community?`,
                "Warning",
                {
                    confirmButtonText: "OK",
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            )
                .then(() => {
                    window.axios
                        .post(
                            `/web-api/community/${community.id}/suspension-status`,
                            {
                                suspended: !community.suspended
                            }
                        )
                        .then(() => {
                            this.$notify.success({
                                message: `Community has been ${
                                    !community.suspended
                                        ? "suspended"
                                        : "un-suspended"
                                }`
                            });
                            this.$store.commit(
                                Mutations.CHANGE_SUSPENSION_STATUS,
                                community
                            );
                        });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        currentIssueDate(date) {
            if (date == null) {
                return "(no order)";
            } else {
                return moment(date).format("MMMM YYYY");
            }
        },
        onChangeCorporation(value) {
            switch (value) {
                case null:
                case "":
                    this.currentQuery.filter = _.omit(
                        this.currentQuery.filter,
                        ["corporation_id"]
                    );
                    break;
                case "independent":
                    this.currentQuery.filter.corporation_id = null;
                    break;
                default:
                    this.currentQuery.filter.corporation_id = value;
                    break;
            }
            this.updateRoute();
        }
    },
    watch: {}
};
</script>

<style lang="scss" scoped>
.community-locations {
    .community-locations__item {
        &:not(:first-of-type) {
            margin-top: 1rem;
        }
    }
}
</style>
